import { render, staticRenderFns } from "./TicketDetailNewReport.vue?vue&type=template&id=1d718ebb&scoped=true&"
import script from "./TicketDetailNewReport.vue?vue&type=script&lang=js&"
export * from "./TicketDetailNewReport.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetailNewReport.vue?vue&type=style&index=0&id=1d718ebb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d718ebb",
  null
  
)

export default component.exports